import { useEffect, useState } from 'react';

export const MOBILE_BREAKPOINT = 768;
export const MOBILE_SIDEBAR_WIDTH = 68;
export const MOBILE_CONTENT_MARGIN_LEFT = 82;
export const DESKTOP_SIDEBAR_WIDTH = 220;
export const DESKTOP_CONTENT_MARGIN_LEFT = 240;

const getIsMobileViewport = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return window.innerWidth <= MOBILE_BREAKPOINT;
};

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(getIsMobileViewport);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getIsMobileViewport());
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};

export default useIsMobile;
